module.exports = __webpack_public_path__ + "media/images/ribbon1-b56b0321277df27e9f499a2514e8e49d.png";